var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"nyeremenyjatek app-block\"\u003E\u003Cnyeremenyjatek-feliratkozas ng-show=\"$ctrl.visibleModule.subscribe\" captcha=\"$ctrl.captcha\" errors=\"$ctrl.subscribeErrors\" on-submit=\"$ctrl.subscribe(object)\"\u003E\u003C\u002Fnyeremenyjatek-feliratkozas\u003E\u003Cnyeremenyjatek-kerdesek ng-show=\"$ctrl.visibleModule.quiz\" on-submit=\"$ctrl.submitQuiz(object)\"\u003E\u003C\u002Fnyeremenyjatek-kerdesek\u003E\u003Cnyeremenyjatek-osszegzo ng-show=\"$ctrl.visibleModule.summary\"\u003E\u003C\u002Fnyeremenyjatek-osszegzo\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./source/applications/nyeremenyjatek/nyeremenyjatek.pug
// module id = 295
// module chunks = 1